interface DocumentStatusBadgeProps {
  label: string
  tone?: 'green' | 'amber' | 'blue' | 'gray' | 'red'
}

export default function DocumentStatusBadge({ label, tone = 'gray' }: DocumentStatusBadgeProps) {
  const classes: Record<typeof tone, string> = {
    green: 'border-green-300 bg-green-50 text-green-800',
    amber: 'border-amber-300 bg-amber-50 text-amber-800',
    blue: 'border-blue-300 bg-blue-50 text-blue-800',
    gray: 'border-slate-300 bg-slate-50 text-slate-700',
    red: 'border-red-300 bg-red-50 text-red-800',
  }

  return <span className={`inline-flex rounded border px-2 py-1 text-[11px] font-semibold uppercase tracking-[0.22em] ${classes[tone]}`}>{label}</span>
}
